import { useQuery } from '@tanstack/react-query';
import { fetchUserById } from '../services/users';
import { userKeys } from './useUsersQuery';
import type { AdminUser } from '../types/users.types';

export const useUserQuery = (id: string) => {
    return useQuery<AdminUser>({
        queryKey: userKeys.detail(id),
        queryFn: () => fetchUserById(id),
        enabled: !!id,
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
